import { IDropdownOption, Link, TextField } from "@fluentui/react";
import { textFieldStyles } from "../../../common/views/DefaultStyles";
import { Utils } from "../../../common/views/Utils";
import { PopUpType } from "../../../home/models/OtherTypes";
import { MenuModel } from "../../models/CategoryModel";
import { NewGroupModel } from "../../models/NewProductModel";
import SelectBrandView from "../shared/SelectBrandView";
import SelectCategoryView from "../shared/SelectCategoryView";

interface GroupInputProps {
    form: NewGroupModel;
    onValueChange: (field: keyof NewGroupModel, value: any) => void;
    brandOptions: IDropdownOption[];
    categoryList: MenuModel[];
    getSelectedCategoryList: () => MenuModel[];
    onCategoryChecked: (category: MenuModel, checked: boolean) => void;
    onCategoryCollapsed: (category: MenuModel, collapsed: boolean) => void;
}

export default function GroupInputView({
    form, onValueChange, brandOptions, categoryList,
    getSelectedCategoryList, onCategoryChecked, onCategoryCollapsed
}: GroupInputProps) {
    const width2 = Utils.getColumnWidth(2);
    const width10 = Utils.getColumnWidth(10);

    const nameCapitalize = () => {
        onValueChange("name", Utils.toCapital(form.name));
    }

    const nameInput = () => {
        return <div className="pb-10">
            <TextField
                label="Name"
                value={form.name}
                onChange={(_, v) => onValueChange("name", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const specInput = () => {
        return <div className="pb-10">
            <TextField
                label="Specification"
                value={form.specification}
                multiline
                rows={10}
                onChange={(_, v) => onValueChange("specification", v || "")} />
        </div>;
    }

    const noteInput = () => {
        return <div className="pb-10">
            <TextField
                label="Internal Note"
                value={form.note}
                multiline
                rows={3}
                onChange={(_, v) => onValueChange("note", v || "")} />
        </div>;
    }

    const msrpInput = () => {
        return <div className="pb-10">
            <TextField
                label="Msrp $"
                value={form.msrp.toString()}
                type={"number"}
                onChange={(_, v) => onValueChange("msrp", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const priceInput = () => {
        return <div className="pb-10">
            <TextField
                label="Price $"
                value={form.price.toString()}
                type={"number"}
                onChange={(_, v) => onValueChange("price", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const shippingInput = () => {
        return <div className="pb-10">
            <TextField
                label="Shipping $"
                value={form.shipping.toString()}
                type={"number"}
                onChange={(_, v) => onValueChange("shipping", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const feeInput = () => {
        return <div className="pb-10">
            <TextField
                label="Fee $"
                value={form.fee.toString()}
                type={"number"}
                onChange={(_, v) => onValueChange("fee", v || "")}
                styles={textFieldStyles}
            />
        </div>;
    }

    const priceElement = () => {
        const className3 = Utils.getColumnWidth(3);

        return <div className="ms-Grid-row">
            <div className={className3}>
                {msrpInput()}
            </div>
            <div className={className3}>
                {priceInput()}
            </div>
            <div className={className3}>
                {shippingInput()}
            </div>
            <div className={className3}>
                {feeInput()}
            </div>
        </div>
    }

    return <div className="p-15">
        <SelectBrandView
            value={form.brandId}
            type={PopUpType.modal}
            onChange={(value: number) => onValueChange("brandId", value)}
            options={brandOptions}
        />

        <div className="ms-Grid-row pv-10">
            <div className={width10}>
                {nameInput()}
            </div>
            <div className={width2 + " right"} style={{ paddingTop: 33 }}>
                <u><Link href="#" onClick={nameCapitalize} className="font-bold">Capitalize</Link></u>
            </div>
        </div>

        <SelectCategoryView
            list={categoryList}
            getSelectedList={getSelectedCategoryList}
            onChecked={onCategoryChecked}
            onCollapsed={onCategoryCollapsed}
        />

        <div className="pt-10">{specInput()}</div>
        <div className="pt-10">{noteInput()}</div>
        <div className="pt-10">{priceElement()}</div>
    </div>;
}